/*
 * Preview Carousel
 * Version: 2.5.0
 */

ckdc.ready( function( $ ) {
    // main ckdc object required
    if ( typeof ckdc == 'undefined' ) {
		return;
    }

	var previewListCounter = 0;
	var orientation = null;

    /*
     * Setup
     */

    ckdc.setup.addSetupContent( 'preview-carousel', setupContent );
    ckdc.window.resize( function() {
		updateAllCarouselsOrientation();
    } );

	function setupContent( newContent ) {
		var newPreviewCarousels = newContent.find(".preview-list.carousel:not(.init)");

		newPreviewCarousels.each(function() {
			setupPreviewCarousel(this);
		});
	}

	function setupPreviewCarousel(carousel) {
		
		var previewCarousel = $( carousel );
		var carouselId
		var previewListItemsWrapper;
		var sliderContent;
		var previewItems;
		var pageIndicator;
		var itemWidth;
		var itemsNextPage;
		var mouseEnterItemTimeout;
		var okToZoomItem = false;
		var scrolling = false;
		var alignWithContent = false;

		function init() {
			previewListCounter++;
			previewCarousel.attr("id", "preview-list-carousel-" + previewListCounter);
			carouselId = previewCarousel.attr("id");
			previewListItemsWrapper = previewCarousel.find(".preview-list-items");
			sliderContent = previewCarousel.find(".slider-content");
			previewItems = sliderContent.find(".preview-item");

			updateCarouselOrientation( previewCarousel );

			if ( ckdc.isMobile ) {
				previewCarousel.addClass("mobile");
			} else {
				//should the carousel in a full width section be aligned with content in a fixed width section.
				alignWithContent = previewCarousel.hasClass('align-with-content');

				//render pagination buttons
				previewListItemsWrapper.prepend('<span class="pagination prev"><i class="pagination-icon"></i></span>');
				previewListItemsWrapper.append('<span class="pagination next"><i class="pagination-icon"></i></span>');

				//render page indicator
				previewCarousel.prepend('<aside class="page-indicator"><ul><li class="active"></li></ul></aside>');
				pageIndicator = previewCarousel.find(".page-indicator");
				updatePageIndicator(0);

				// add item index number to each preview item in the list
				addItemIndex(previewItems);

				// set initial left positions
				setLeftPos();
				
				//pagination handlers
				previewCarousel.on( "click", ".pagination.next", moveToNextPage );
				previewCarousel.on( "click", ".pagination.prev", moveToPrevPage );

				//add event handler for the carousel
 				previewCarousel.on( "mouseleave", mouseLeaveCarousel );

				//add event handler for the slider
				previewCarousel.on( "mouseleave", ".slider-content", mouseLeaveSlider );

				//add event handler for the preview items
				sliderContent.on( "mouseenter", ".preview-item", mouseEnterItem );
				
				//set visability of pagination 
				setPaginationVisibility();
			}
			previewCarousel.addClass("init");
		}

		function addItemIndex(list) {
			list.each( function( i, e ) {
				$(e).attr("data-index", i);
			});
		}

		function setLeftPos() {
			previewItems.each( function( i, e ) {
				var item = $(e);
				item.data("left", item.position().left);
			});
		}
		
		function isItemFirstOnPage(item) {
			var firstItem = getFirstItemInView();
			if ( item.data("index") == firstItem.data("index") ) {
				return true;
			}
			return  false;
		}

		function getFirstItemInView(part, fromPos) { 
			var partDivider = 2;
			if ( part == "fully" ) {
				partDivider = 1;
			}
			if ( fromPos == undefined ) {
				fromPos = 0;
			}
			var item = $();
			previewItems.each( function( i, e ) {
				item = $(e);
				var itemOffsetLeft = item.offset().left;
				var itemWidth = item.width();
				var checkPos = ( itemOffsetLeft + itemWidth ) - ( itemWidth / partDivider );
				if ( checkPos > fromPos ) {
					return false;
				}
			});
			return item;
		}
		
		function isItemLastOnPage(item) {
			var lastItem = getLastItemInView();
			if ( item.data("index") == lastItem.data("index") ) {
				return true;
			}
			return  false;
		}

		function getLastItemInView(part) { 
			var partDivider = 2;
			if ( part == "fully" ) {
				partDivider = 1;
			}
			var reversedList = $(previewItems.get().reverse());
			var item = $();
			reversedList.each( function( i, e ) {
				item = $(e);
				if ( ( item.data("left") + ( item.width() / partDivider ) ) < previewCarousel.width() ) {
					return false;
				}
			});
			return item;
		}

		function moveToNextPage(event) {
			if ( !scrolling ) {
				var lastItem = getLastItemInView("fully");
				var scrollto = (sliderContent.scrollLeft() + lastItem.data("left") + lastItem.width()) - parseFloat(sliderContent.css("padding-left")) + 10;
				scrollSliderTo(scrollto);
			}
		}

		function moveToPrevPage(event) {
			if ( !scrolling ) {
				var firstItem = getFirstItemInView("fully");
				var sliderScrollLeft = sliderContent.scrollLeft();
				var carouselWidth = previewCarousel.width();
				var firstItemLeft = firstItem.data("left");
				var scrollto = 0 - ( carouselWidth - firstItemLeft ) ;
				firstItem = getFirstItemInView("fully", scrollto);
				if ( firstItem.data("index") == 0 ) {
					scrollto = 0;
				} else {
					firstItemLeft = firstItem.data("left");
					scrollto = sliderScrollLeft + firstItemLeft - parseFloat(sliderContent.css("padding-left"));
				}
				scrollSliderTo(scrollto);
			}
		}
		
		function tweakScrollForItem(item) {
			var scrollto;
			var itemLeft = item.data("left");
			var itemRight = itemLeft + item.width();
			var sliderScrollLeft = sliderContent.scrollLeft();
			var carouselWidth = previewCarousel.width();
			
			if ( itemLeft < 0 ) {
				scrollto = sliderScrollLeft + itemLeft - 10;
				scrollSliderTo(scrollto);
			}
			else if ( itemRight > carouselWidth ) {
				scrollto = sliderScrollLeft + (itemRight - carouselWidth) + 10;
				scrollSliderTo(scrollto);
			}
		}

		function scrollSliderTo(scrollto) {
			scrolling = true;
			updatePageIndicator(scrollto);
			sliderContent.animate({
				scrollLeft: scrollto
			}, {
				duration: 1000,
				specialEasing: {
					scrollLeft: $.bez([0.500, 0.000, 0.000, 1.000])
				},
				complete: function() {
					setPaginationVisibility();
					setLeftPos();
					scrolling = false;
				}
			});
		}

		function updatePageIndicator(scrollto) {
			scrollto = typeof scrollto !== 'undefined' ? scrollto : 0;
			var pageWidth = previewCarousel.width();
			var sliderWidth = sliderContent[0].scrollWidth;
			var pagePercentage = 100 * pageWidth / sliderWidth;
			var pageLeft = 100 * scrollto / sliderWidth;
			var pageItem = pageIndicator.find("li");
			pageItem.css("width", pagePercentage + "%").css("left", pageLeft + "%");
		}

		function setPaginationVisibility() {
			var rightPos = sliderContent.scrollLeft() + sliderContent.outerWidth();
			var leftPos = sliderContent.scrollLeft();

			// Prev pagination
			if ( leftPos <= 0 ) {
				previewCarousel.find(".pagination.prev").css("display", "none").css("opacity", "0");
			} else {
				previewCarousel.find(".pagination.prev").show().css("display", "").css("opacity", "");
			}

			// Next pagination
			if ( rightPos >= sliderContent[0].scrollWidth ) {
				previewCarousel.find(".pagination.next").css("display", "none").css("opacity", "0");
			} else {
				previewCarousel.find(".pagination.next").show().css("display", "").css("opacity", "");
			}
		}

		function mouseLeaveCarousel() {
			previewCarousel.removeClass("hover");
		}

		function mouseLeaveSlider() {
			okToZoomItem = false;
		}

		function mouseEnterItem(e) {
			setPaginationVisibility();
			var item = $(e.currentTarget);

			var links = item.find("a");
			links.attr("title", "");

			var sizes = item.hasClass( 'orientation-vertical' ) ? ckdc.carouselZoomedSizesVt : ckdc.carouselZoomedSizes;
			item.find("img").attr("sizes", sizes);

			if ( okToZoomItem ) {
				previewCarousel.addClass("hover");
				itemEnterHandler(item);
			} else {
				if (mouseEnterItemTimeout != null) { clearTimeout(mouseEnterItemTimeout); }

				// To zoom only when the mouse moves over an item, not when the cursor gets scrolled in.
				// The nested mousmove event handlers is only to support Safari, as Safari triggers both mouseenter and mousemove when
				// the mouse cursor gets on an item by scrolling the page, whereas Chrome and Edge only triggers mouseenter.
				window.lastX = e.clientX;
				window.lastY = e.clientY;
				item.one("mousemove", function(e) {
					mouseEnterItemTimeout = setTimeout(function() {
						item.one("mousemove", function(ev) {
							if (window.lastX !== ev.clientX || window.lastY !== ev.clientY) {
								mouseEnterItemTimeout = setTimeout(function() {
									previewCarousel.addClass("hover");
									okToZoomItem = true;
									itemEnterHandler(item);
								}, 200);
							}
						});
					}, 100);
				});

				item.one("mouseleave", function() {
					item.off("mousemove");
					if (mouseEnterItemTimeout != null) {
						clearTimeout(mouseEnterItemTimeout);
						mouseEnterItemTimeout = null;
					}
				});
			}
		}

		function itemEnterHandler(item) {
			
			tweakScrollForItem(item);

			ckdc.preview.extraImagesHandling(item);
			item.addClass("selected");
			item.prevAll().addClass("beforeSelectedItem");
			item.nextAll().addClass("afterSelectedItem");
			if ( isItemFirstOnPage(item) ) {
				sliderContent.addClass("firstItem");
				item.addClass("firstItem");
			} else if ( isItemLastOnPage(item) ) {
				sliderContent.addClass("lastItem");
				item.addClass("lastItem");
			}
			item.one("mouseleave", function(e) {
				var item = $(e.currentTarget);
				previewCarousel.removeClass("hover");
				item.removeClass("selected");
				sliderContent.removeClass("firstItem");
				item.removeClass("firstItem");
				sliderContent.removeClass("lastItem");
				item.removeClass("lastItem");
				item.prevAll().removeClass("beforeSelectedItem");
				item.nextAll().removeClass("afterSelectedItem");
			});
		}

		init();

	}

	function updateAllCarouselsOrientation() {
		var o = 'orientation-' + ckdc.orientation;

		var dualCarousels = $( '.carousel-dual-orientation', ckdc.body );
		if ( ! dualCarousels.length ) {
			return;
		}

		dualCarousels.each( function() {
			updateCarouselOrientation( $( this ) );
		} );
	};

	function updateCarouselOrientation( carousel ) {
		setOrientation( carousel );

		var carouselItems = $( '.preview-item', carousel );
		if ( ! carouselItems.length ) {
			return;
		}
		carouselItems.each( function() {
			setOrientation( $( this ) );
		} );
	}

	function setOrientation( obj ) {
	    var o = 'orientation-' + ckdc.orientation;
	    if ( obj.hasClass( o ) ) {
			return;
	    }

	    obj.removeClass( 'orientation-vertical orientation-horizontal' ).addClass( o );
	};

	(function(factory) {
		if (typeof exports === "object") {
		  factory(require("jquery"));
		} else if (typeof define === "function" && define.amd) {
		  define(["jquery"], factory);
		} else {
		  factory(jQuery);
		}
	  }(function($) {
		$.extend({ bez: function(encodedFuncName, coOrdArray) {
		  if ($.isArray(encodedFuncName)) {
			coOrdArray = encodedFuncName;
			encodedFuncName = 'bez_' + coOrdArray.join('_').replace(/\./g, 'p');
		  }
		  if (typeof $.easing[encodedFuncName] !== "function") {
			var polyBez = function(p1, p2) {
			  var A = [null, null], B = [null, null], C = [null, null],
				  bezCoOrd = function(t, ax) {
					C[ax] = 3 * p1[ax], B[ax] = 3 * (p2[ax] - p1[ax]) - C[ax], A[ax] = 1 - C[ax] - B[ax];
					return t * (C[ax] + t * (B[ax] + t * A[ax]));
				  },
				  xDeriv = function(t) {
					return C[0] + t * (2 * B[0] + 3 * A[0] * t);
				  },
				  xForT = function(t) {
					var x = t, i = 0, z;
					while (++i < 14) {
					  z = bezCoOrd(x, 0) - t;
					  if (Math.abs(z) < 1e-3) break;
					  x -= z / xDeriv(x);
					}
					return x;
				  };
			  return function(t) {
				return bezCoOrd(xForT(t), 1);
			  }
			};
			$.easing[encodedFuncName] = function(x, t, b, c, d) {
			  return c * polyBez([coOrdArray[0], coOrdArray[1]], [coOrdArray[2], coOrdArray[3]])(t/d) + b;
			}
		  }
		  return encodedFuncName;
		}});
	  }));

});
